import { Button } from "antd";
import "./deliveryButton.css";
import { UserAddOutlined } from "@ant-design/icons";

export function PlussoButton() {
  <button>
    <div className="svg-wrapper-1">
      <div className="svg-wrapper">
        <svg
          className="icon"
          height="30"
          width="30"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22,15.04C22,17.23 20.24,19 18.07,19H5.93C3.76,19 2,17.23 2,15.04C2,13.07 3.43,11.44 5.31,11.14C5.28,11 5.27,10.86 5.27,10.71C5.27,9.33 6.38,8.2 7.76,8.2C8.37,8.2 8.94,8.43 9.37,8.8C10.14,7.05 11.13,5.44 13.91,5.44C17.28,5.44 18.87,8.06 18.87,10.83C18.87,10.94 18.87,11.06 18.86,11.17C20.65,11.54 22,13.13 22,15.04Z"></path>
        </svg>
      </div>
    </div>
    <span>Save</span>
  </button>;
}

const Plusbutton = () => {
  const title = "";
  function setAddExamVisible(arg0: boolean): void {
    throw new Error("Function not implemented.");
  }

  return (
    <>
      <button
        className="buttonc centered"
        onClick={() => setAddExamVisible(true)}
      >
        <span className="buttonc__text">Nuovo Paziente</span>
        <span className="buttonc__icon">
          <UserAddOutlined rev={undefined} />
        </span>
      </button>
    </>
  );
};

export default Plusbutton;
